import { HomeSliceType, OurNewsSlice } from '../../../../types/slice';
import { toNumber, toText } from '../../fields';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ourNewsSlice = (data: Record<string, any>): OurNewsSlice | undefined => {
  if (data.primary?.enabled !== 'oui') {
    return undefined;
  }

  const title = toText(data.primary?.title);
  if (!title) {
    return undefined;
  }

  return {
    title,
    type: HomeSliceType.OUR_NEWS,
    nbTiles: toNumber(data.primary?.nbTiles, {
      defaultValue: 20,
    }),
  };
};

export default ourNewsSlice;
